import { render, staticRenderFns } from "./SendReceiptsSMS.vue?vue&type=template&id=67381ae5&scoped=true"
import script from "./SendReceiptsSMS.vue?vue&type=script&lang=js"
export * from "./SendReceiptsSMS.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "67381ae5",
  null
  
)

export default component.exports